import { motion } from "framer-motion";

export const SectionLabel = ({ children, ...props }) => (
  <span {...props} className="text-xs uppercase tracking-[0.2em] text-blue-500 font-semibold">
    {children}
  </span>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
